// web/src/api/me.ts
//
// Typed wrappers for /api/v1/me. Uses the shared apiFetch from client.ts
// so JWT + X-Organization-Id injection + 401 retry are all handled uniformly.
import { apiFetch } from "./client";

export type OrgSummary = {
  id: string;
  name: string;
  is_personal: boolean;
  role: string;
};

export type MeResponse = {
  user_id: string;
  email: string | null;
  created_at: string | null;
  preferred_language: string;
  organizations: OrgSummary[];
};

export type PatchMePayload = {
  name?: string;
  preferred_language?: string;
};

export const meApi = {
  get: () => apiFetch<MeResponse>("/api/v1/me"),
  patch: (body: PatchMePayload) =>
    apiFetch<MeResponse>("/api/v1/me", {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }),
  delete: () => apiFetch<void>("/api/v1/me", { method: "DELETE" }),
};
